import { collection, query } from 'firebase/firestore'

import { COLLECTIONS } from '__constants__'
import firestore from 'services/firebase/firestore'
import { useCollectionData } from 'react-firebase-hooks/firestore'
import { useMemo } from 'react'

const useGetContent = (contentType) => {
  const [contents = [], loading, error] = useCollectionData(
    query(collection(firestore, COLLECTIONS.CONTENT))
  )

  const contentData = contents?.find(
    (item) => item?.contentType === contentType
  )

  return useMemo(
    () => [contentData, loading, error],
    [contents, loading, error]
  )
}

export default useGetContent
